export function objectGetAt(path: string | string[], source: any) {
    if (!Array.isArray(path))
        path = path.split('.');
    const result = path.reduce((o: any, i) => {
        return o[i];
    }, source);
    if (result?.bind) {
        return result.bind(source)
    } else {
        return result
    }
}